import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';
import { injectIntl, defineMessages } from 'react-intl';
import { withRouter } from 'react-router-dom';
import gql from 'graphql-tag';
import { withAccount } from '../../components/AccountContext';
import { withGrowl } from '../../components/GrowlNotifications';
import { growlErrors, growlActionSuccess } from '../../utils/NotificationUtil';
import { growlShape } from '../../components/prop-types';
import UploadLogo from './UploadLogo';

const messages = defineMessages({
  updateLogoSuccess: {
    id: 'update.logo.success',
    defaultMessage: 'Logo updated.',
  },
});

const UPLOAD_LOGO = gql`mutation ($input: UpdateLogoOfAccountInput!) {
  updateLogoOfAccount(input: $input) {
    account {
    id
    }
  }
}`;

const UploadLogoContainer = (props) => {
  const [updateLogoOfAccount] = useMutation(
    UPLOAD_LOGO,
    { refetchQueries: ['querySingleAccountById'] },
  );

  const onUpload = async (files) => {
    const {
      currentAccount, growl,
    } = props;
    const file = files[0];
    try {
      await updateLogoOfAccount({
        variables: {
          input: {
            accountId: currentAccount,
            // for using file drop component, the field name need to be mapped
            // to the input id, in this case, it's always 1
            fieldName: '1',
          },
          file,
        },
      }).then(() => growlActionSuccess(growl, messages.logoUpdated));
    } catch (errors) {
      growlErrors(growl, errors);
    }
  };

  return (
    <UploadLogo
      {...props}
      onUpload={files => onUpload(files)}
    />
  );
};

UploadLogoContainer.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
};

export default withGrowl(
  withRouter(
    injectIntl(
      withAccount(UploadLogoContainer),
    ),
  ),
);
